import React, {
  Fragment,
  useContext,
  useEffect,
  useState,
  useRef,
} from "react";
import CssBaseline from "@mui/material/CssBaseline";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import Button from "@mui/material/Button";
import { AlertContext } from "../../../context/AlertContext";
import { Link, Redirect } from "react-router-dom";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import DialogTitle from "@mui/material/DialogTitle";
import Box from "@mui/material/Box";
import { AuthContext } from "../../../context/AuthContext";
import { ConfiguracionContext } from "../../../context/ConfiguracionContext";
import Spinner from "../Spinner";
import { styled } from "@mui/material/styles";
import { Navigate, useNavigate } from "react-router-dom";
import { Toast } from "primereact/toast";
import Barra from "../Barra";

export default function NumeroInterno(props) {
  //const classes = useStyles();

  const alertContext = useContext(AlertContext);
  const { mensajeAlerta } = alertContext;

  const authContext = useContext(AuthContext);
  const { state, usuarioAutenticado } = authContext;

  const configuracionContext = useContext(ConfiguracionContext);
  const {
    statusAcceso,
    configuracion,
    obtenerAcceso,
    actualizarConfiguracion,
    obtenerConfiguracion,
    guardarConfiguracion,
  } = configuracionContext;

  const toast = useRef(null);
  let navigate = useNavigate();

  useEffect(() => {
    usuarioAutenticado();
  }, [state.id]);

  useEffect(() => {
    if (state.usuario) {
      obtenerAcceso({ usuarioId: state.usuario.id, layout: "NumeroInterno" });
    }
    obtenerConfiguracion();
  }, [state.id]);

  setTimeout(() => {
    if (statusAcceso === 400) {
      accesoDenegado();
    }
  }, 3000);

  const aceptarClick = (e) => {
    e.preventDefault();

    // extraer de usuario
    const {
      edadPediatrico,
      diurnoDesde,
      diurnoHasta,
      nocturnoDesde,
      nocturnoHasta,
    } = configuracion;

    //Validar
    if (edadPediatrico === 0) {
      mensajeAlerta("Parámetros", "edad es necesario !.", "error");
      return;
    }
    if (diurnoDesde === "") {
      mensajeAlerta("Parámetros", "Diurno desde es necesario !.", "error");
      return;
    }
    if (diurnoHasta === "") {
      mensajeAlerta("Parámetros", "Diurno hasta es necesario !.", "error");
      return;
    }

    actualizarConfiguracion(configuracion);
  };

  const exitClick = (e) => {
    navigate(`/`);
  };

  const accesoDenegado = () => {
    mensajeAlerta(
      "Accesos",
      "No tiene permiso para acceder a esta pantalla !.",
      "error",
    );
    exitClick();
    return;
  };

  //console.log(configuracion)

  return (
    <Fragment>
      <Barra />
      <Toast ref={toast} />
      {statusAcceso === 0 || statusAcceso === 400 ? <Spinner /> : null}
      {statusAcceso === 200 ? (
        <Fragment>
          <Grid container spacing={2} style={{ marginTop: "1vw" }}>
            <Grid item xs={12} md={12} style={{ marginLeft: "1em" }}>
              <DialogTitle id="id">
                <Box display="flex" alignItems="center" marginLeft="1em">
                  <Box flexGrow={1}>{"Parámetros del sistema"}</Box>
                  <Box>
                    <IconButton component={Link} to="/">
                      <CloseIcon style={{ color: "#3F51B5" }} />
                    </IconButton>
                  </Box>
                </Box>
              </DialogTitle>
            </Grid>
            <Grid item xs={5} md={2} style={{ marginLeft: "1em" }}>
              <TextField
                required
                id="edadPediatrico"
                name="edadPediatrico"
                label="Edad Pediátrico Hasta "
                fullWidth
                autoComplete="given-name"
                variant="standard"
                value={configuracion.edadPediatrico}
                onChange={(e) =>
                  guardarConfiguracion({
                    ...configuracion,
                    edadPediatrico: e.target.value,
                  })
                }
              />
            </Grid>
            <Grid item xs={5} md={2}>
              <TextField
                id="diurnoDesde"
                label="Servicio diurno desde"
                type="time"
                value={configuracion.diurnoDesde}
                fullWidth
                variant="standard"
                InputLabelProps={{
                  shrink: true,
                }}
                inputProps={{
                  step: 300, // 5 min
                }}
                onChange={(e) =>
                  guardarConfiguracion({
                    ...configuracion,
                    diurnoDesde: e.target.value,
                  })
                }
              />
            </Grid>
            <Grid
              item
              xs={5}
              md={2}
              sx={{
                marginLeft: "1em",
              }}
            >
              <TextField
                id="diurnoHasta"
                label="Servicio diurno hasta"
                type="time"
                value={configuracion.diurnoHasta}
                fullWidth
                variant="standard"
                InputLabelProps={{
                  shrink: true,
                }}
                inputProps={{
                  step: 300, // 5 min
                }}
                onChange={(e) =>
                  guardarConfiguracion({
                    ...configuracion,
                    diurnoHasta: e.target.value,
                  })
                }
              />
            </Grid>
            <Grid item xs={5} md={2}>
              <TextField
                id="nocturnoDesde"
                label="Servicio nocturno desde"
                type="time"
                value={configuracion.diurnoHasta}
                InputLabelProps={{
                  shrink: true,
                }}
                fullWidth
                variant="standard"
                disabled
                inputProps={{
                  step: 300, // 5 min
                }}
              />
            </Grid>
            <Grid
              item
              xs={5}
              md={2}
              sx={{
                marginLeft: "1em",
              }}
            >
              <TextField
                id="nocturnoHasta"
                label="Servicio nocturno hasta"
                type="time"
                defaultValue={configuracion.diurnoDesde}
                InputLabelProps={{
                  shrink: true,
                }}
                disabled
                fullWidth
                variant="standard"
                inputProps={{
                  step: 300, // 5 min
                }}
              />
            </Grid>

            <Grid
              item
              xs={12}
              md={4}
              sx={{
                marginLeft: "0em",
              }}
            >
              <FormControlLabel
                value="yes"
                control={
                  <Checkbox
                    id="farmacia"
                    color="primary"
                    checked={configuracion ? configuracion.medicamentos : false}
                    //onKeyDown={handleEnter}
                    onChange={(e) =>
                      guardarConfiguracion({
                        ...configuracion,
                        medicamentos: e.target.checked,
                      })
                    }
                  />
                }
                label="Utilizar carga de medicamentos en cierre del servicio"
                labelPlacement="start"
              />
            </Grid>

            <Grid
              item
              xs={12}
              md={4}
              sx={{
                marginLeft: "0em",
              }}
            >
              <FormControlLabel
                value="yes"
                control={
                  <Checkbox
                    id="location"
                    color="primary"
                    checked={configuracion ? configuracion.location : false}
                    //onKeyDown={handleEnter}
                    onChange={(e) =>
                      guardarConfiguracion({
                        ...configuracion,
                        location: e.target.checked,
                      })
                    }
                  />
                }
                label="Habilitar geolocalización en celulares de móviles."
                labelPlacement="start"
              />
            </Grid>

            {/*   
            <Grid item xs={12} md={12} style={{ paddingLeft: 0 }}>
              <FormControlLabel
                value="yes"
                control={
                  <Checkbox
                    id="hc"
                    color="primary"
                    checked={configuracion ? configuracion.hc : false}
                    //onKeyDown={handleEnter}
                    onChange={(e) =>
                      guardarConfiguracion({
                        ...configuracion,
                        hc: e.target.checked,
                      })
                    }
                  />
                }
                label="Habilitar carga de H.C. en dispositivos móviles."
                labelPlacement="start"
              />
            </Grid>
            */}

            <Grid
              item
              xs={12}
              md={3}
              sx={{
                marginLeft: "0em",
              }}
            >
              <FormControlLabel
                value="yes"
                control={
                  <Checkbox
                    id="alertas"
                    color="primary"
                    checked={configuracion ? configuracion.alertas : false}
                    //onKeyDown={handleEnter}
                    onChange={(e) =>
                      guardarConfiguracion({
                        ...configuracion,
                        alertas: e.target.checked,
                      })
                    }
                  />
                }
                label="Habilitar alertas en pantalla despachos."
                labelPlacement="start"
              />
            </Grid>

            <Grid item xs={12} md={12} style={{ marginLeft: "1em" }}>
              <DialogTitle id="id">
                <Box display="flex" alignItems="center" marginLeft="1em">
                  <Box flexGrow={1}>{"Links Móviles Propios"}</Box>
                </Box>
              </DialogTitle>
            </Grid>

            <Grid item xs={12} md={3} style={{ marginLeft: "1em" }}>
              <FormControlLabel
                value="yes"
                control={
                  <Checkbox
                    id="movilesPantalla"
                    color="primary"
                    checked={
                      configuracion ? configuracion.movilespantalla : false
                    }
                    //onKeyDown={handleEnter}
                    onChange={(e) =>
                      guardarConfiguracion({
                        ...configuracion,
                        movilespantalla: e.target.checked,
                      })
                    }
                  />
                }
                label="Pantalla."
                labelPlacement="start"
              />
            </Grid>

            <Grid item xs={12} md={3}>
              <FormControlLabel
                value="yes"
                control={
                  <Checkbox
                    id="movilesWhatsApp"
                    color="primary"
                    checked={
                      configuracion ? configuracion.movileswhatsapp : false
                    }
                    //onKeyDown={handleEnter}
                    onChange={(e) =>
                      guardarConfiguracion({
                        ...configuracion,
                        movileswhatsapp: e.target.checked,
                      })
                    }
                    disabled={configuracion && !configuracion.whapi}
                  />
                }
                label="WhatsApp."
                labelPlacement="start"
              />
            </Grid>

            {configuracion && configuracion === 4 ? (
              <Grid item xs={12} md={3}>
                <FormControlLabel
                  value="yes"
                  control={
                    <Checkbox
                      id="movilesTelegram"
                      color="primary"
                      checked={
                        configuracion ? configuracion.movilestelegram : false
                      }
                      //onKeyDown={handleEnter}
                      onChange={(e) =>
                        guardarConfiguracion({
                          ...configuracion,
                          movilestelegram: e.target.checked,
                        })
                      }
                    />
                  }
                  label="Telegram."
                  labelPlacement="start"
                />
              </Grid>
            ) : null}

            <Grid item xs={12} md={12} style={{ marginLeft: "1em" }}>
              <DialogTitle id="id">
                <Box display="flex" alignItems="center" marginLeft="1em">
                  <Box flexGrow={1}>{"Links Móviles Telemedicina"}</Box>
                </Box>
              </DialogTitle>
            </Grid>

            <Grid item xs={12} md={3} style={{ marginLeft: "1em" }}>
              <FormControlLabel
                value="yes"
                control={
                  <Checkbox
                    id="telemedicinaPantalla"
                    color="primary"
                    checked={
                      configuracion ? configuracion.telemedicinapantalla : false
                    }
                    //onKeyDown={handleEnter}
                    onChange={(e) =>
                      guardarConfiguracion({
                        ...configuracion,
                        telemedicinapantalla: e.target.checked,
                      })
                    }
                  />
                }
                label="Pantalla."
                labelPlacement="start"
              />
            </Grid>

            <Grid item xs={12} md={3}>
              <FormControlLabel
                value="yes"
                control={
                  <Checkbox
                    id="telemedicinaWhatsApp"
                    color="primary"
                    checked={
                      configuracion ? configuracion.telemedicinawhatsapp : false
                    }
                    //onKeyDown={handleEnter}
                    onChange={(e) =>
                      guardarConfiguracion({
                        ...configuracion,
                        telemedicinawhatsapp: e.target.checked,
                      })
                    }
                    disabled={configuracion && !configuracion.whapi}
                  />
                }
                label="WhatsApp."
                labelPlacement="start"
              />
            </Grid>

            {configuracion && configuracion === 4 ? (
              <Grid item xs={12} md={3}>
                <FormControlLabel
                  value="yes"
                  control={
                    <Checkbox
                      id="telemedicinaTelegram"
                      color="primary"
                      checked={
                        configuracion
                          ? configuracion.telemedicinatelegram
                          : false
                      }
                      //onKeyDown={handleEnter}
                      onChange={(e) =>
                        guardarConfiguracion({
                          ...configuracion,
                          telemedicinatelegram: e.target.checked,
                        })
                      }
                    />
                  }
                  label="Telegram."
                  labelPlacement="start"
                />
              </Grid>
            ) : null}

            <Grid item xs={12} md={12} style={{ marginLeft: "1em" }}>
              <DialogTitle id="id">
                <Box display="flex" alignItems="center" marginLeft="1em">
                  <Box flexGrow={1}>{"Recetas Telemedicina"}</Box>
                </Box>
              </DialogTitle>
            </Grid>

            <Grid item xs={12} md={3} style={{ marginLeft: "1em" }}>
              <FormControlLabel
                value="yes"
                control={
                  <Checkbox
                    id="recetasEmail"
                    color="primary"
                    checked={configuracion ? configuracion.recetasemail : false}
                    //onKeyDown={handleEnter}
                    onChange={(e) =>
                      guardarConfiguracion({
                        ...configuracion,
                        recetasemail: e.target.checked,
                      })
                    }
                  />
                }
                label="Email."
                labelPlacement="start"
              />
            </Grid>

            <Grid item xs={12} md={3}>
              <FormControlLabel
                value="yes"
                control={
                  <Checkbox
                    id="recetasWhatsApp"
                    color="primary"
                    checked={
                      configuracion ? configuracion.recetaswhatsapp : false
                    }
                    //onKeyDown={handleEnter}
                    onChange={(e) =>
                      guardarConfiguracion({
                        ...configuracion,
                        recetaswhatsapp: e.target.checked,
                      })
                    }
                    disabled={configuracion && !configuracion.whapi}
                  />
                }
                label="WhatsApp."
                labelPlacement="start"
              />
            </Grid>

            {/*    
            <Grid item xs={12} md={3}>
              <FormControlLabel
                value="yes"
                control={
                  <Checkbox
                    id="recetasTelegram"
                    color="primary"
                    checked={
                      configuracion ? configuracion.recetastelegram : false
                    }
                    //onKeyDown={handleEnter}
                    onChange={(e) =>
                      guardarConfiguracion({
                        ...configuracion,
                        recetastelegram: e.target.checked,
                      })
                    }
                  />
                }
                label="Telegram."
                labelPlacement="start"
              />
            </Grid>
            */}

            <Grid item xs={12} md={12}></Grid>

            <Grid item xs={6} md={5} style={{ marginLeft: "5em" }}>
              <Button
                type="button"
                fullWidth
                variant="contained"
                style={{ backgroundColor: "green" }}
                onClick={aceptarClick}
              >
                Aceptar
              </Button>
            </Grid>
            <Grid item xs={6} md={5}>
              <Button
                type="button"
                fullWidth
                variant="contained"
                style={{ backgroundColor: "#D8261C" }}
                onClick={exitClick}
              >
                Cancelar
              </Button>
            </Grid>
          </Grid>
        </Fragment>
      ) : null}
    </Fragment>
  );
}
